import { addDoc, getDocs, collection, doc, deleteDoc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { asyncToaster } from '../utils/utility-functions';
import { toasterNotifications } from '../constants';

export const getWorkOrdersService = async () => {
    const data = await getDocs(collection(db, "workOrders"));
    return data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
}

export const addWorkOrder = (workOrder) => {
    const addWorkOrder = addDoc(collection(db, 'workOrders'), workOrder);

    // update work order id
    const workOrderRef = doc(db, "workOrderCounter", "counter");
    updateDoc(workOrderRef, {
        counter: workOrder.workOrderId
    });

    asyncToaster(addWorkOrder, toasterNotifications.addWorkOrder);
    return addWorkOrder;
}

export const deleteWorkOrders = (id) => {
    const workOrder = deleteDoc(doc(db, 'workOrders', id));
    asyncToaster(workOrder, toasterNotifications.deleteWorkOrder);
    return workOrder;
};

export const getWorkOrderCounter = async () => {
    const workOrder = await getDocs(collection(db, "workOrderCounter"));
    const workOrderCounter = workOrder.docs.map(doc => ({ ...doc.data() }))
    
    return workOrderCounter[0].counter;
};

export const getWorkOrder = async (id) => {
    const docRef = doc(db, "workOrders", id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data()

    return data;
};